import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserProfile } from '@lyceo/shared/auth/util-models';
import { AUTH_FEATURE_KEY, AuthState } from './auth.reducer';
import { getError, LoadingState } from '@lyceo/shared/util-loading';
import { selectGuardsLoaded } from '@lyceo/shared/data-access';

export const selectAuthState =
  createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated,
);

export const selectLoginCallState = createSelector(
  selectAuthState,
  (state: AuthState) => state.loginCallState,
);

export const selectLoginLoading = createSelector(
  selectLoginCallState,
  (callState) => callState === LoadingState.LOADING,
);

export const selectLoginError = createSelector(
  selectLoginCallState,
  (callState) => getError(callState),
);

export const selectHasLoginError = createSelector(
  selectLoginError,
  (error) => !!error,
);

export const selectIsDoneLoading = createSelector(
  selectLoginCallState,
  (callState) =>
    callState !== LoadingState.INIT && callState !== LoadingState.LOADING,
);

export const selectLogoutCallState = createSelector(
  selectAuthState,
  (state: AuthState) => state.logoutCallState,
);

export const selectLogoutStarted = createSelector(
  selectLogoutCallState,
  (callState) => callState !== LoadingState.INIT,
);

export const selectUserProfile = createSelector(
  selectAuthState,
  (state: AuthState) => state.profile,
);

export const selectUserId = createSelector(
  selectUserProfile,
  (profile: UserProfile | undefined) => profile?.person_id,
);

export const selectUserEmail = createSelector(
  selectUserProfile,
  (profile: UserProfile | undefined) => profile?.email,
);

export const selectUserFullName = createSelector(
  selectUserProfile,
  (profile: UserProfile | undefined) => profile?.full_name,
);

export const selectUserRoles = createSelector(
  selectUserProfile,
  (profile: UserProfile | undefined) => profile?.roles ?? [],
);

export const selectShowLoader = createSelector(
  selectLoginLoading,
  selectLogoutStarted,
  selectGuardsLoaded,
  (loginLoading, logoutStarted, guardsLoaded) =>
    loginLoading || logoutStarted || !guardsLoaded,
);
